import React from 'react';
import { Bottleneck } from '../../types/dashboard';
import { AlertOctagon, Sparkles, ChevronRight, Clock } from 'lucide-react';
interface BottleneckPanelProps {
  bottlenecks: Bottleneck[];
}
export function BottleneckPanel({
  bottlenecks
}: BottleneckPanelProps) {
  return <div className="bg-white rounded-xl border border-slate-200 shadow-sm flex flex-col h-full" data-id="element-13">
      <div className="p-5 border-b border-slate-100 flex justify-between items-center" data-id="element-14">
        <h3 className="font-bold text-slate-800 flex items-center gap-2" data-id="element-15">
          <AlertOctagon className="w-5 h-5 text-rose-500" data-id="element-16" />
          Active Bottlenecks
        </h3>
        <span className="bg-rose-100 text-rose-700 px-2 py-1 rounded-full text-xs font-bold" data-id="element-17">
          {bottlenecks.length} Critical
        </span>
      </div>

      <div className="flex-1 overflow-y-auto p-2 space-y-2" data-id="element-18">
        {bottlenecks.map(item => <div key={item.id} className="group p-4 rounded-lg border border-slate-100 hover:border-blue-200 hover:bg-blue-50/30 transition-all cursor-pointer" data-id="element-19">
            <div className="flex justify-between items-start mb-2" data-id="element-20">
              <div data-id="element-21">
                <div className="flex items-center gap-2 mb-1" data-id="element-22">
                  <span className="font-bold text-slate-900" data-id="element-23">
                    {item.loanId}
                  </span>
                  <span className="px-2 py-0.5 bg-slate-100 text-slate-600 text-xs rounded font-medium" data-id="element-24">
                    {item.stage}
                  </span>
                </div>
                <div className="flex items-center gap-1 text-xs text-rose-600 font-medium" data-id="element-25">
                  <Clock className="w-3 h-3" data-id="element-26" />
                  Stuck for {item.duration}
                </div>
              </div>
              <ChevronRight className="w-4 h-4 text-slate-300 group-hover:text-blue-500 transition-colors" data-id="element-27" />
            </div>

            
          </div>)}
      </div>

      <div className="p-3 border-t border-slate-100 bg-slate-50 rounded-b-xl text-center" data-id="element-28">
        <button className="text-sm text-blue-600 font-medium hover:text-blue-800" data-id="element-29">
          View All Alerts
        </button>
      </div>
    </div>;
}